import { render, staticRenderFns } from "./custom-select-bb.vue?vue&type=template&id=568ba3e0&scoped=true"
import script from "./custom-select-bb.vue?vue&type=script&lang=js"
export * from "./custom-select-bb.vue?vue&type=script&lang=js"
import style0 from "./custom-select-bb.vue?vue&type=style&index=0&id=568ba3e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568ba3e0",
  null
  
)

export default component.exports